import {
  useEffect,
  useState
} from 'react';
import { useLocation, useSession } from 'hooks';
import {
  AvatarBtn,
  Container,
  NavDropdown
} from './styles';
import Div from 'ui/Div';


function AvatarDropdown({ children }) {

  const { user } = useSession()

  const {
    isCreators,
    pathname
  } = useLocation()

  const [isOpen, setIsOpen] = useState(false)

  const toggle = () => setIsOpen(prev => !prev)
  const open = () => setIsOpen(true)
  const close = () => setIsOpen(false)


  useEffect(() => {
    if (!isOpen) return

    const closeEvent = (e) => {
      e.preventDefault();
      close()
    }

    window.addEventListener('click', closeEvent, { passive: false })
    window.addEventListener('scroll', closeEvent, { passive: false })

    return () => {
      window.removeEventListener('click', closeEvent, { passive: false })
      window.removeEventListener('scroll', closeEvent, { passive: false })
    }
  }, [isOpen])


  useEffect(() => {
    close()
  }, [pathname])


  return (
    <Container onClick={(e) => e.stopPropagation()}>
      <Div role='button' onClick={toggle}>
        <AvatarBtn
          src={user.profile?.avatar}
          $isActive={isOpen}
          $isCreators={isCreators}
        />
      </Div>


      <NavDropdown $isOpen={isOpen} $isCreators={isCreators}>
        { typeof children === 'function'
          ? children({ isOpen, open, close, toggle })
          : children
        }
      </NavDropdown>
    </Container>
  )
}

export default AvatarDropdown